import { render, staticRenderFns } from "./mbTargetuser.vue?vue&type=template&id=a74ca66a&scoped=true&"
import script from "./mbTargetuser.vue?vue&type=script&lang=js&"
export * from "./mbTargetuser.vue?vue&type=script&lang=js&"
import style0 from "./mbTargetuser.vue?vue&type=style&index=0&id=a74ca66a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a74ca66a",
  null
  
)

export default component.exports